import React, { FC, useState } from 'react';
import { Box, Divider, Typography, useTheme } from '@mui/material';
import { SentimentVeryDissatisfied, SentimentVerySatisfied } from '@mui/icons-material';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import ReviewWrapper from '../ReviewWrapper';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import ReviewFooter from '../ReviewFooter';
import { useTranslation } from 'react-i18next';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';

interface Props extends IReviewNewProps {}

const OmrReview: FC<Props> = ({
  communityManagement,
  commentingModule,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [showAllBlocks, setShowAllBlocks] = useState(false);

  const {
    header,
    rating,
    companyComment,
    reviewLink,
    blocks,
    username,
    text,
    positiveFeedback,
    negativeFeedback,
  } = reviewEntry.review;

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      reviewLink={reviewLink}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {(username || text) && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {username && (
            <Typography
              variant="caption"
              sx={{
                color: theme.palette.text.secondary,
                mb: theme.spacing(1),
              }}
            >
              {username}
            </Typography>
          )}
          {text && (
            <Typography
              variant="caption"
              sx={{
                color: theme.palette.text.secondary,
                cursor: 'pointer',
              }}
            >
              {text}
            </Typography>
          )}
        </Box>
      )}
      <Divider orientation="horizontal" />
      {header && (
        <Typography
          variant="h6"
          sx={{
            mt: theme.spacing(1),
            mb: theme.spacing(1),
          }}
        >
          {header}
        </Typography>
      )}
      <Divider orientation="horizontal" />
      {positiveFeedback && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            m: theme.spacing(2),
          }}
        >
          <SentimentVerySatisfied sx={{ color: theme.palette.success.dark }} />
          <Typography sx={{ ml: theme.spacing(3) }}>{positiveFeedback}</Typography>
        </Box>
      )}
      {negativeFeedback && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            m: theme.spacing(2),
          }}
        >
          <SentimentVeryDissatisfied sx={{ color: theme.palette.error.dark }} />
          <Typography sx={{ ml: theme.spacing(3) }}>{negativeFeedback}</Typography>
        </Box>
      )}
    </ReviewWrapper>
  );
};

export default OmrReview;
